import { render, staticRenderFns } from "./fichaTecnica.vue?vue&type=template&id=3de0c253&scoped=true&"
import script from "./fichaTecnica.vue?vue&type=script&lang=js&"
export * from "./fichaTecnica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de0c253",
  null
  
)

export default component.exports